import { TOMATO_AWARDS } from '@tomato/shared';
import { useState } from 'react';

import { buildInviteUrl, shareInvite } from '../lib/referral';
import { useSessionStore } from '../store/session';
import { Button, Notice } from './ui';

/**
 * 친구 초대(A) — 소문 전파의 핵심. 내 초대 링크를 카톡 등으로 공유하고,
 * 친구가 가입하면 100토마토가 적립된다. 설정과 환영 화면에서 함께 쓴다.
 */
export function InvitePanel({ bare = false }: { bare?: boolean }) {
  const me = useSessionStore((s) => s.me);
  const [note, setNote] = useState('');

  if (!me?.referralCode) return null;
  const url = buildInviteUrl(me.referralCode);

  async function onShare() {
    const result = await shareInvite(url);
    setNote(
      result === 'copied'
        ? '초대 링크를 복사했어요. 붙여넣어 보내세요.'
        : result === 'failed'
          ? '링크 복사에 실패했어요. 아래 주소를 직접 복사해 주세요.'
          : '',
    );
  }

  const body = (
    <>
      <p className="text-[15px] font-medium text-ink-900">친구 초대하기</p>
      <p className="mt-1 text-[13px] leading-relaxed text-ink-500">
        동료가 이 링크로 가입하면 <b className="text-tomato-600">{TOMATO_AWARDS.referral}토마토</b>를
        드려요. 회사 메일이면 누구나 들어올 수 있어요.
      </p>

      <div className="mt-3 flex items-center gap-2">
        <input
          readOnly
          value={url}
          onFocus={(e) => e.currentTarget.select()}
          className="min-w-0 flex-1 rounded-lg bg-ink-50 px-3 py-2 text-[12px] text-ink-500 hairline"
        />
        <Button size="sm" onClick={() => void onShare()}>
          공유
        </Button>
      </div>

      <Notice tone="info">{note}</Notice>
    </>
  );

  if (bare) return <div>{body}</div>;
  return <div className="rounded-2xl bg-surface p-5 shadow-card">{body}</div>;
}
